import { useLayouts } from 'src/hooks/LayoutHooks';

export const GlobalStoreSetup = () => {
  useLayouts();

  return null;
};
